import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getGtnNumberByCollectionPointIDandDate,
    getAllAllJobCodesForDropdown,
    getWorkDistributionDetails,
    getAllJobCategoriesForDropdown
};

async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}
async function getAllJobCategoriesForDropdown() {
    var jobCategoryArray = [];
    const response = await CommonGet('/api/WorkDistributionReport/GetAllJobCategories', null)
    for (let item of Object.entries(response.data)) {
        jobCategoryArray[item[1]["estateTaskID"]] = item[1]["estateTaskName"]

    }
    return jobCategoryArray;
}

async function getAllAllJobCodesForDropdown() {
    const response = await CommonGet('/api/WorkDistributionReport/GetAllJobCodes', null)
    return response.data;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}


async function getGtnNumberByCollectionPointIDandDate(data) {
    var gtnArray = [];
    var model = {
        collectionPointID: parseInt(data.divisionID),
        searchDate: data.searchDate
    }
    const response = await CommonPost('/api/GoodsTransferNote/GetGtnNumberByCollectionPointIDandDate', null, model);
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            gtnArray[item[1]["gtnNumber"]] = item[1]["gtnNumber"]
        }
    }
    return gtnArray;
}

async function getWorkDistributionDetails(data) {
    var model = {
        divisionID: parseInt(data.divisionID),
        estateTaskID: parseInt(data.estateTaskID),
        taskID: parseInt(data.taskID),
        fromDate: data.fromDate,
        toDate: data.toDate,
    };

    const response = await CommonPost('/api/WorkDistributionReport/GetWorkDistributionReport', null, model);


    return response.data;
}
